// Collapses long text (collection description) to a few lines with a "Show more" / "Show less" button.
// Without JavaScript the full text shows and the button stays hidden.
if (!customElements.get('joli-show-more')) {
  customElements.define(
    'joli-show-more',
    class JoliShowMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.joli-show-more__content');
        this.button = this.querySelector('.joli-show-more__toggle');
        if (!this.content || !this.button) return;

        this.button.addEventListener('click', () => this.toggle());
        this.measure();
        // Web fonts and images can change the height after the first measurement.
        if (document.fonts) document.fonts.ready.then(() => this.measure());
        window.addEventListener('load', () => this.measure(), { once: true });
      }

      measure() {
        if (this.hasAttribute('expanded')) return;
        this.setAttribute('collapsed', '');
        // Only collapse when it hides a meaningful amount of text, not just one more line.
        const hidden = this.content.scrollHeight - this.content.clientHeight;
        const worthCollapsing = hidden > 48;
        this.toggleAttribute('collapsed', worthCollapsing);
        this.button.hidden = !worthCollapsing;
      }

      toggle() {
        const expand = !this.hasAttribute('expanded');
        this.toggleAttribute('expanded', expand);
        this.toggleAttribute('collapsed', !expand);
        this.button.setAttribute('aria-expanded', String(expand));

        // After "Show less", bring the start of the text back into view if it scrolled away.
        if (!expand && this.getBoundingClientRect().top < 0) {
          this.scrollIntoView({ block: 'start' });
        }
      }
    }
  );
}
